import { IGetGateway } from '../gateways';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import {
  BicString,
  CreditInstituteString,
  IbanString,
  IInstitutionData,
  INSTITUTION_DATA_SCHEMA,
} from '@web/dtos';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';

export class PaymentInstituteDataGateway implements IGetGateway<
  IbanString,
  IApiResponse<IInstitutionData>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<
    IbanString,
    IInstitutionData
  > = new RestCallBuilder<IbanString, IInstitutionData>({
    bic: '' as BicString,
    creditInstitute: '' as CreditInstituteString,
  });

  get(query: IbanString): Observable<IApiResponse<IInstitutionData>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.paymentUrl}/bank/institute-data?iban=${query}`
      )
      .validate(
        API_RESPONSE_SCHEMA(INSTITUTION_DATA_SCHEMA),
        'InstituteData.get'
      )
      .handleMessages()
      .build();
  }
}
